import { z } from 'zod';
import type { QueryResponse } from '@/types/api-types';
import type { paths } from '~/generated/auth/api-schema';
import { zodRemoveNullable } from '@/lib/zod-helper';
import { currentUserResSchema } from '~/generated/auth/zod-schema';
import { bareAuthApi } from './bare-auth-api';

const PATH = '/v1/auth/current-user' as const;
const TIMEOUT_MS = 10_000;

type CurrentUserResponse = QueryResponse<paths, typeof PATH>;

const { tenantId, id, name, roles, apiPermissions } =
  zodRemoveNullable(currentUserResSchema).shape;

const currentUserDataSchema = z.object({
  tenantId,
  id,
  name,
  email: z.email(),
  roles: roles.default([]),
  apiPermissions: apiPermissions.default([]),
});

export const fetchCurrentUser = async (token: string) => {
  const { data: response } = await bareAuthApi.get<CurrentUserResponse>(PATH, {
    headers: { Authorization: `Bearer ${token}` },
    timeout: TIMEOUT_MS,
  });

  return currentUserDataSchema.parse(response.data);
};
